<template>
  <a v-if="result?.picture" :href="result.link" class="categories-item categories-item-picture">
    <DefImg :result="result.picture" :max-size-off="true" />
    <span class="categories-item__name">{{ result.name }}</span>
  </a>
  <a v-else-if="result?.animation" :href="result.link" class="categories-item">
    <DefImg :result="result.animation" :max-size-off="true" />
    <span class="categories-item__name">{{ result.name }}</span>
  </a>
  <a
    v-else-if="result?.video"
    :href="result.link"
    class="categories-item"
    @mouseenter="handlerMouseEnter"
    @mouseleave="handlerMouseleave"
  >
    <DefVideo :result="result.video" :play="play" />
    <span class="categories-item__name">{{ result.name }}</span>
  </a>
</template>

<script lang="ts" setup>
import { ICategoriesItem } from '@components/Categories/ICategories';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import DefVideo from '@components/Def/DefVideo/DefVideo.vue';
import { ref } from 'vue';

const play = ref(false);

const props = defineProps<{
  result: ICategoriesItem;
}>();

const handlerMouseEnter = () => {
  play.value = true;
};

const handlerMouseleave = () => {
  play.value = false;
};
</script>

<style lang="scss" scoped>
.categories-item {
  position: relative;
  overflow: hidden;
  &__name {
    position: absolute;
    bottom: 24px;
    left: 50%;
    transform: translate(-50%);
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 1.28px;
    text-transform: uppercase;
    color: #fff;
    text-align: center;
  }
}
.categories-item-picture {
  :deep(.def-img) {
    transition: 0.2s linear transform;
  }
  &:hover {
    :deep(.def-img) {
      transform: scale(1.2);
    }
  }
}
</style>
